var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column justify-content-center"},[_c('LoadingAnimation',{attrs:{"color":'Grey'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }